<template>
  <div class="assistance__register-panel">
    <h2 class="assistance__register-title">Cadastrar Acesso</h2>

    <hr />

    <div class="form-group">
      <label for="assistance-cpf-cnpj" ref="assistance-cpf-cnpj">
        Cpf/Cnpj
        <small>(Utilizado na compra do produto FortG)</small>
      </label>

      <input
        type="tel"
        name="cpf_cnpj"
        ref="assistance-cpf-cnpj"
        v-model="customer.cpf_cnpj"
        v-validate="cpfCnpjRules"
        v-mask="['###.###.###-##', '##.###.###/####-##']"
        class="form-control"
        :class="{'error': errors.has('cpf_cnpj')}"
        id="assistance-cpf-cnpj"
        autocapitalize="off"
        autocomplete="off"
        autocorrect="off"
      />

      <span class="vee-error">{{errors.first('cpf_cnpj')}}</span>
    </div>

    <template v-if="customerCanRegister">
      <div class="form-group">
        <label for="assistance-name" ref="assistance-name">Nome</label>

        <input
          type="text"
          name="name"
          v-model="customer.name"
          ref="assistance-name"
          v-validate="'required'"
          class="form-control"
          :class="{'error': errors.has('name')}"
          id="assistance-name"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
        />

        <span class="vee-error">{{errors.first('name')}}</span>
      </div>

      <div class="form-group">
        <label for="assistance-email" ref="assistance-email">Email</label>

        <input
          type="email"
          name="email"
          v-model="customer.email"
          ref="assistance-email"
          v-validate="'required|email'"
          class="form-control"
          :class="{'error': errors.has('email')}"
          id="assistance-email"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
        />

        <span class="vee-error">{{errors.first('email')}}</span>
      </div>

      <div class="form-group">
        <label for="assistance-password" ref="assistance-password">Senha</label>

        <input
          type="password"
          name="password"
          v-model="customer.password"
          ref="assistance-password"
          v-validate="'required'"
          class="form-control"
          :class="{'error': errors.has('password')}"
          id="assistance-password"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
        />

        <span class="vee-error">{{errors.first('password')}}</span>
      </div>

      <div class="form-group">
        <label for="assistance-phone" ref="assistance-phone">Telefone</label>

        <input
          type="tel"
          name="phone"
          v-model="customer.phone"
          v-mask="['(##) ####-####', '(##) #####-####']"
          ref="assistance-phone"
          v-validate="'required'"
          class="form-control"
          :class="{'error': errors.has('phone')}"
          id="assistance-phone"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
        />

        <span class="vee-error">{{errors.first('phone')}}</span>
      </div>
    </template>

    <btn-send :sending-form="sendingForm"></btn-send>
  </div>
</template>

<script>
import BtnSend from "./BtnSend.vue";
import api from "../support/api";

export default {
  components: {
    BtnSend
  },

  created() {
    bus.$on("assistance/validateNewCustomerForm", () => {
      this.validateBeforeSubmit();
    });
  },

  data() {
    return {
      sendingForm: false,

      customerCanRegister: false,

      customer: {
        name: "",
        cpf_cnpj: "",
        email: "",
        password: "",
        phone: ""
      }
    };
  },

  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result && !this.customerCanRegister) {
          api.validateNewCustomer(this);
        } else if (result && this.customerCanRegister) {
          api.saveCustomer(this);
        }
      });
    },

    scrollToFirstError() {
      const firstField = Object.keys(this.errors.collect())[0];
      this.$refs[`assistance-${firstField}`].scrollIntoView();
    }
  },

  computed: {
    cpfCnpjRules() {
      let fieldLength = 14;

      return {
        required: true,
        cpf: this.customer.cpf_cnpj.length < fieldLength,
        cnpj: this.customer.cpf_cnpj.length > fieldLength
      };
    },

    cpfCnpjClean() {
      let str = this.customer.cpf_cnpj;

      str = str.replace(/\./g, "");
      str = str.replace(/\-/g, "");
      str = str.replace(/\//g, "");

      return str;
    }
  }
};
</script>
